import { render, staticRenderFns } from "./ContractInfoDomain.vue?vue&type=template&id=465c152c"
import script from "./ContractInfoDomain.vue?vue&type=script&lang=js"
export * from "./ContractInfoDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports